function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.136 12.72a.76.76 0 00.766-.755.76.76 0 00-.766-.755h-.01a.76.76 0 00-.766.755.76.76 0 00.766.755h.01z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 1.116a6.884 6.884 0 100 13.768A6.884 6.884 0 008 1.116zM0 8a8 8 0 1116 0A8 8 0 010 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.822 9.42c0 .736-1.322.737-1.322 0V4c0-.678 1.322-.672 1.322 0v5.42z"
}));
function SvgCirculoconexclamacion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Circulo con exclamacion.svg";
export { SvgCirculoconexclamacion as ReactComponent };